import gql from 'graphql-tag';

import { commentFragment } from './GeneralCommentFragment.fragment';

export const CreateGeneralCommentMutation = gql`
	mutation CreateGeneralCommentMutation($pageId: ID!, $cloudId: ID!, $input: CreateCommentInput!) {
		createFooterComment(cloudId: $cloudId, input: $input) {
			...commentFragment
		}
	}

	${commentFragment}
`;
